/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

import { UpdateFuturesContractsByIdRequest } from './data-contracts';
import { ContentType, HttpClient, RequestParams } from './http-client';

export class RefFuturesContractsMassUpdates<
  SecurityDataType = unknown,
> extends HttpClient<SecurityDataType> {
  /**
   * No description
   *
   * @name UpdateFuturesContracts
   * @request POST:/refFuturesContracts-mass-updates
   * @secure
   */
  updateFuturesContracts = (data: UpdateFuturesContractsByIdRequest, params: RequestParams = {}) =>
    this.request<void, any>({
      path: `/refFuturesContracts-mass-updates`,
      method: 'POST',
      body: data,
      secure: true,
      type: ContentType.Json,
      ...params,
    });
  /**
   * No description
   *
   * @name OptionsRefFuturesContractsMassUpdates
   * @request OPTIONS:/refFuturesContracts-mass-updates
   */
  optionsRefFuturesContractsMassUpdates = (params: RequestParams = {}) =>
    this.request<void, any>({
      path: `/refFuturesContracts-mass-updates`,
      method: 'OPTIONS',
      ...params,
    });
}
